/* Aquain: Produktempfehlung nach Anwendung, Wasserhärte und Verbrauch (ergänzt aquain-capacity). */
(() => {
  const aqT = (k, d) => (window.aquainStrings && window.aquainStrings[k]) || d;
  const fmt = new Intl.NumberFormat('de-CH', { maximumFractionDigits: 0 });
  const esc = (s) => String(s == null ? '' : s).replace(/[&<>"']/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]));
  const money = (cents) => 'CHF ' + (cents / 100).toFixed(2);

  async function addToCart(items) {
    const drawer = document.querySelector('cart-drawer');
    const notification = document.querySelector('cart-notification');
    const target = drawer || notification;
    let sections = ['cart-icon-bubble'];
    if (target && typeof target.getSectionsToRender === 'function') {
      sections = target.getSectionsToRender().map((s) => s.section || s.id);
    }
    const root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    const res = await fetch(root + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items, sections: sections.join(','), sections_url: window.location.pathname }),
    });
    const data = await res.json();
    if (!res.ok || data.status) throw new Error(data.description || data.message || 'Fehler');
    const first = data.items ? data.items[0] : data;
    let rendered = false;
    if (target && typeof target.renderContents === 'function' && data.sections) {
      try {
        if (drawer && drawer.classList.contains('is-empty')) drawer.classList.remove('is-empty');
        target.renderContents(Object.assign({}, data, { key: first.key, id: first.id }));
        rendered = true;
      } catch (e) { rendered = false; }
    }
    if (!rendered) await refreshBubble(data.sections);
    if (window.publish && window.PUB_SUB_EVENTS) {
      try { window.publish(window.PUB_SUB_EVENTS.cartUpdate, { source: 'aquain-empfehlung', productVariantId: first.variant_id, cartData: data }); } catch (e) {}
    }
    return data;
  }

  async function refreshBubble(sections) {
    const bubble = document.getElementById('cart-icon-bubble');
    if (!bubble) return;
    if (sections && sections['cart-icon-bubble']) {
      const html = new DOMParser().parseFromString(sections['cart-icon-bubble'], 'text/html');
      const inner = html.querySelector('.shopify-section');
      bubble.innerHTML = inner ? inner.innerHTML : html.body.innerHTML;
      return;
    }
    try {
      const cart = await (await fetch('/cart.js')).json();
      let count = bubble.querySelector('.cart-count-bubble span[aria-hidden]');
      if (count) count.textContent = cart.item_count;
    } catch (e) {}
  }

  class AquainRecommendation {
    constructor(calc) {
      this.calc = calc;
      this.data = JSON.parse(calc.querySelector('[data-reco-data]').textContent);
      this.app = calc.querySelector('[data-application]');
      this.hardness = calc.querySelector('[data-hardness]');
      this.unit = calc.querySelector('[data-unit]');
      this.daily = calc.querySelector('[data-daily]');
      this.hint = calc.querySelector('[data-daily-hint]');
      this.panel = calc.querySelector('[data-reco]');
      this.auto = false;
      this.app.addEventListener('change', () => this.onApplication());
      this.daily.addEventListener('input', () => { if (!this.prefilling) { this.auto = false; this.updateHint(); } });
      calc.addEventListener('input', (e) => {
        if (e.target.matches && e.target.matches('[data-conn]')) { this.connChoice = e.target.value; this.updateConnInfo(); return; }
        if (e.target !== this.app) this.update();
      });
      this.panel.addEventListener('click', (e) => this.onClick(e));
      if (this.app.value) this.onApplication(); else this.update();
    }
    rule() { return this.data.rules[this.app.value] || null; }
    connOptions() { return (this.data.connection && this.data.connection.options) || []; }
    connFor(key) { return this.connOptions().find((o) => o.key === key) || null; }
    resetConn() {
      const rule = this.rule();
      const opts = this.connOptions();
      const pre = rule && this.connFor(rule.connection) ? rule.connection : (opts[0] ? opts[0].key : null);
      this.connChoice = pre;
    }
    connProps() {
      const o = this.connFor(this.connChoice);
      if (!o) return null;
      const props = {}; props[this.data.connection.property || 'Anschluss'] = o.label;
      if (this.data.connection.tpo) props._tpo_add_by = String(this.data.connection.tpo);
      return props;
    }
    connHtml(rule) {
      const opts = this.connOptions();
      if (!opts.length) return '';
      if (!this.connFor(this.connChoice)) this.resetConn();
      const name = 'aq-conn-' + (this.calc.querySelector('[data-application]').id || 'x');
      return '<fieldset class="aq-reco-conn"><legend>' + esc(aqT('conn_legend', 'Anschluss der Flasche:')) + '</legend><div class="aq-reco-conn__opts">' +
        opts.map((o) => '<label class="aq-reco-conn__opt"><input type="radio" data-conn name="' + esc(name) + '" value="' + esc(o.key) + '"' + (o.key === this.connChoice ? ' checked' : '') + '><span>' + esc(o.short) + '</span>' +
          (rule && o.key === rule.connection ? '<span class="aq-reco-conn__rec">' + esc(aqT('conn_recommended', 'empfohlen')) + '</span>' : '') + '</label>').join('') +
        '</div><p class="aq-reco-conn__info" data-conn-info></p></fieldset>';
    }
    updateConnInfo() {
      const el = this.panel.querySelector('[data-conn-info]');
      const o = this.connFor(this.connChoice);
      if (el) el.textContent = o ? (o.key === 'gardena' ? aqT('conn_gardena', 'Die Flasche wird mit Gardena-Schnellkupplung geliefert (Standard, ohne Aufpreis).') : aqT('conn_with', 'Die Flasche wird mit ') + o.short + aqT('conn_suffix', '-Anschlüssen geliefert (ohne Aufpreis).')) : '';
    }
    onApplication() {
      this.resetConn();
      const rule = this.rule();
      if (rule && rule.daily > 0 && (this.daily.value === '' || this.auto)) {
        this.prefilling = true;
        this.daily.value = rule.daily;
        this.auto = true;
        this.daily.dispatchEvent(new Event('input', { bubbles: true }));
        this.prefilling = false;
      } else if (rule && !(rule.daily > 0) && this.auto) {
        this.prefilling = true;
        this.daily.value = '';
        this.auto = false;
        this.daily.dispatchEvent(new Event('input', { bubbles: true }));
        this.prefilling = false;
      }
      this.updateHint();
      this.update();
    }
    updateHint() {
      const rule = this.rule();
      if (rule && this.auto) {
        this.hint.innerHTML = '<strong>Richtwert:</strong> ca. ' + fmt.format(rule.daily) + ' l/Tag.';
        this.hint.hidden = false;
      } else if (rule && this.daily.value === '') {
        this.hint.textContent = aqT('daily_hint', 'Geben Sie Ihren Verbrauch pro Tag ein, damit wir die Grösse genauer empfehlen können.');
        this.hint.hidden = false;
      } else {
        this.hint.hidden = true;
      }
    }
    card(p, opts) {
      const img = p.image ? '<img src="' + esc(p.image) + '" alt="' + esc(p.alt) + '" width="160" height="160" loading="lazy">' : '';
      const link = opts.main ? '<a class="button button--secondary" href="' + esc(p.url) + '">Zum Produkt</a>' : '';
      const label = opts.main ? aqT('add_to_cart', 'In den Warenkorb') : aqT('add', 'Hinzufügen');
      return '<div class="aq-reco-card">' +
        '<a class="aq-reco-card__img" href="' + esc(p.url) + '" tabindex="-1" aria-hidden="true">' + img + '</a>' +
        '<div><a class="aq-reco-card__title" href="' + esc(p.url) + '">' + esc(p.title) + '</a><span class="aq-reco-card__price">' + esc(p.price) + '</span></div>' +
        (opts.conn || '') +
        '<div class="aq-reco-card__actions">' + link +
        '<button type="button" class="button ' + (opts.main ? 'button--primary' : 'button--secondary') + '" data-add="' + p.variant + '"' + (opts.main || opts.bottle ? ' data-bottle' : '') + (p.available ? '' : ' disabled') +
        ' aria-label="' + esc(label + ': ' + p.title) + '">' + (p.available ? label : 'Ausverkauft') + '</button></div></div>';
    }
    update() {
      const rule = this.rule();
      const rows = this.calc.querySelectorAll('tr[data-model]');
      rows.forEach((r) => { r.classList.remove('is-recommended', 'is-alternative', 'is-spar'); const b = r.querySelector('[data-badge]'); if (b) { b.hidden = true; b.className = 'aq-reco-badge'; } });
      if (!rule) { this.panel.hidden = true; return; }
      const hardness = Number(this.hardness.value);
      const reference = Number(this.unit.value);
      const daily = Number(this.daily.value);
      const hasDaily = this.daily.value !== '' && Number.isFinite(daily) && daily > 0;
      this.panel.hidden = false;
      const title = this.panel.querySelector('[data-reco-title]');
      const reason = this.panel.querySelector('[data-reco-reason]');
      title.textContent = aqT('for', 'Für ') + rule.label;
      if (!(Number.isFinite(hardness) && hardness > 0)) {
        reason.hidden = false;
        reason.textContent = aqT('enter_hardness', 'Bitte geben Sie Ihre Wasserhärte ein.');
        this.render(null, null, rule, false);
        return;
      }
      reason.textContent = '';
      reason.hidden = true;
      const max = rule.max > 0 ? Math.max(rule.max, rule.min) : 4;
      const models = this.data.models.filter((m) => m.product && m.index >= rule.min && m.index <= max);
      const litres = (m) => m.capacity * reference / hardness;
      let rec = null; let short = false;
      if (hasDaily) {
        rec = models.find((m) => litres(m) / daily >= rule.days) || null;
        if (!rec) { rec = models[models.length - 1]; short = true; }
      } else {
        rec = models[0];
      }
      if (!rec) { this.panel.hidden = true; return; }
      const spar = (rule.alt || 'reserve') === 'spar';
      let alt = null;
      if (!short) {
        if (spar) alt = this.data.models.find((m) => m.product && m.index === rec.index - 1) || null;
        else alt = models.find((m) => m.index === rec.index + 1) || null;
      }
      /* Kapazitäts-Erklärung ausgeblendet – Zahlen bleiben in der Tabelle */
      const recRow = this.calc.querySelector('tr[data-model="' + rec.index + '"]');
      if (recRow) { recRow.classList.add('is-recommended'); const b = recRow.querySelector('[data-badge]'); if (b) { b.dataset.label = 'Empfohlen'; b.hidden = false; } }
      if (alt) {
        const altRow = this.calc.querySelector('tr[data-model="' + alt.index + '"]');
        if (altRow) {
          if (spar) { altRow.classList.add('is-spar'); const b = altRow.querySelector('[data-badge]'); if (b) { b.dataset.label = 'Sparvariante'; b.className = 'aq-reco-badge aq-reco-badge--spar'; b.hidden = false; } }
          else { altRow.classList.add('is-alternative'); const b = altRow.querySelector('[data-badge]'); if (b) { b.dataset.label = 'Mehr Reserve'; b.className = 'aq-reco-badge aq-reco-badge--alt'; b.hidden = false; } }
        }
      }
      this.render(rec, alt, rule, short, hasDaily ? (m) => Math.floor(litres(m) / daily) : null, spar);
    }
    render(rec, alt, rule, short, daysFor, spar) {
      const main = this.panel.querySelector('[data-reco-main]');
      const altEl = this.panel.querySelector('[data-reco-alt]');
      const noteEl = this.panel.querySelector('[data-reco-note]');
      const accWrap = this.panel.querySelector('[data-reco-acc-wrap]');
      const acc = this.panel.querySelector('[data-reco-acc]');
      const all = this.panel.querySelector('[data-reco-all]');
      this.panel.querySelector('[data-reco-msg]').textContent = '';
      main.innerHTML = rec ? this.card(rec.product, { main: true, conn: this.connHtml(rule) }) : '';
      this.updateConnInfo();
      this.bottleVariants = new Set();
      if (rec && rec.product) this.bottleVariants.add(Number(rec.product.variant));
      if (alt && alt.product) {
        if (spar) {
          altEl.className = 'aq-reco__alt aq-reco__alt--card';
          altEl.innerHTML = '<span class="aq-reco__alt-label">Sparvariante</span>' +
            this.card(alt.product, { main: false, bottle: true }) +
            '<span class="aq-reco__alt-hint">' + esc(alt.name) + aqT('alt_hint', ' – kleiner, häufiger regenerieren.') + '</span>';
          this.bottleVariants.add(Number(alt.product.variant));
        } else {
          altEl.className = 'aq-reco__alt';
          altEl.innerHTML = 'Mehr Reserve: <a href="' + esc(alt.product.url) + '">' + esc(alt.name) + '</a>, ' + esc(alt.product.price) + '.';
        }
        altEl.hidden = false;
      } else { altEl.hidden = true; altEl.className = 'aq-reco__alt'; altEl.innerHTML = ''; }
      const notes = [];
      if (short) notes.push(aqT('short_note', 'Bei diesem Verbrauch regenerieren Sie häufiger.') + (this.data.advice ? ' <a href="' + esc(this.data.advice) + '">' + esc(aqT('request_advice', 'Beratung anfragen')) + '</a>.' : ''));
      if (rule.note) notes.push(esc(rule.note));
      noteEl.innerHTML = notes.join(' ');
      noteEl.hidden = notes.length === 0;
      const items = rule.accessories.filter(Boolean);
      acc.innerHTML = items.map((p) => '<li>' + this.card(p, { main: false }) + '</li>').join('');
      accWrap.hidden = items.length === 0;
      this.bottleVariant = rec && rec.product ? rec.product.variant : null;
      const bundle = [rec && rec.product].concat(items).filter((p) => p && p.available);
      this.bundle = bundle;
      const total = bundle.reduce((s, p) => s + (Number(p.cents) || 0), 0);
      all.textContent = aqT('all_to_cart', 'Alles in den Warenkorb (') + bundle.length + aqT('items', ' Artikel, ') + money(total) + ')';
      all.hidden = !rec || bundle.length < 2;
      all.disabled = false;
    }
    async onClick(e) {
      const btn = e.target.closest('[data-add],[data-reco-all]');
      if (!btn || btn.disabled) return;
      e.preventDefault();
      const msg = this.panel.querySelector('[data-reco-msg]');
      const props = this.connProps();
      const toItem = (id) => { const it = { id: Number(id), quantity: 1 }; if (props && this.bottleVariants && this.bottleVariants.has(Number(id))) it.properties = props; else if (props && Number(id) === Number(this.bottleVariant)) it.properties = props; return it; };
      const items = btn.hasAttribute('data-reco-all') ? this.bundle.map((p) => toItem(p.variant)) : [toItem(btn.dataset.add)];
      const original = btn.textContent;
      btn.disabled = true; btn.setAttribute('aria-busy', 'true'); btn.textContent = aqT('adding', 'Wird hinzugefügt …');
      msg.classList.remove('is-error');
      try {
        await addToCart(items);
        btn.textContent = '✓ Im Warenkorb';
        msg.textContent = items.length > 1 ? items.length + aqT('items_added', ' Artikel wurden in den Warenkorb gelegt.') : aqT('item_added', 'Der Artikel wurde in den Warenkorb gelegt.');
        setTimeout(() => { btn.textContent = original; btn.disabled = false; btn.removeAttribute('aria-busy'); }, 2500);
      } catch (err) {
        btn.textContent = original; btn.disabled = false; btn.removeAttribute('aria-busy');
        msg.classList.add('is-error');
        msg.textContent = aqT('add_error', 'Konnte nicht in den Warenkorb gelegt werden: ') + err.message;
      }
    }
  }

  const init = () => document.querySelectorAll('aquain-capacity').forEach((calc) => {
    if (calc.aqReco || !calc.querySelector('[data-reco-data]')) return;
    calc.aqReco = new AquainRecommendation(calc);
  });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  document.addEventListener('shopify:section:load', init);
})();
